<script setup lang="ts">
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import EntityPreviewTooltip from "~/components/dumb/EntityPreviewTooltip.vue";
import { TypeaheadSpecialEntity } from "~/shared/enums";
import type { TypeaheadOption } from "~/shared/types";

const props = defineProps<{
  item: TypeaheadOption;
}>();

const emit = defineEmits<{
  select: [TypeaheadOption];
}>();

const onClick = (event: Event) => {
  event.stopPropagation();
  emit("select", props.item);
};
</script>

<template>
  <EntityPreviewTooltip
    :task-duid="item.specialEntity === TypeaheadSpecialEntity.TASK ? item.value.toString() : undefined"
    :doc-duid="item.specialEntity === TypeaheadSpecialEntity.DOC ? item.value.toString() : undefined"
    :skill-duid="item.specialEntity === TypeaheadSpecialEntity.SKILL ? item.value.toString() : undefined"
    :user-duid="item.specialEntity === TypeaheadSpecialEntity.USER ? item.value.toString() : undefined"
    block
    @click="onClick">
    <div class="contents">
      <DropdownMenuItemContent
        :title="item.label"
        :icon="item.icon"
        :icon-args="item.iconArgs"
        :strikethrough="item.strikethrough" />
    </div>
  </EntityPreviewTooltip>
</template>
